import { render, staticRenderFns } from "./CreateOrEditPlan.vue?vue&type=template&id=6357208a&scoped=true&"
import script from "./CreateOrEditPlan.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditPlan.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditPlan.vue?vue&type=style&index=0&id=6357208a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6357208a",
  null
  
)

export default component.exports